import { Globe, MessageSquare, Share2, Users } from 'lucide-react';
import { Button, Section, SectionHeading, accent, accentFor, cn } from '../ui';

const CommunitySection = () => {
  const features = [
    { title: 'Study Groups', icon: <Users size={20} aria-hidden="true" />, description: 'Join or create study groups focused on specific subjects or research interests' },
    { title: 'Discussion Forums', icon: <MessageSquare size={20} aria-hidden="true" />, description: 'Engage in thoughtful discussions with peers and experts from around the world' },
    { title: 'Collaborative Projects', icon: <Share2 size={20} aria-hidden="true" />, description: 'Work together on research projects, papers, and academic initiatives' },
    { title: 'Live Events', icon: <Globe size={20} aria-hidden="true" />, description: 'Attend virtual lectures, workshops, and conferences with leading thinkers' },
  ];

  return (
    <Section id="community">
      <SectionHeading
        align="center"
        eyebrow="Community"
        eyebrowAccent={accent('cyan').rule}
        title="Join Our Academic Community"
        description="Connect with like-minded scholars and expand your network"
      />

      {/* Same hairline grid as before, but each way in gets its own accent: the
          icon sits in a tinted tile keyed off the feature name, so the four
          rows read as four different things at a glance. */}
      <ul className="mx-auto grid max-w-4xl grid-cols-1 gap-px overflow-hidden rounded-lg border border-border bg-border sm:grid-cols-2">
        {features.map((feature) => {
          const palette = accentFor(feature.title);

          return (
            <li key={feature.title} className="flex items-start gap-4 bg-background-card p-6">
              <span
                aria-hidden="true"
                className={cn(
                  'flex h-11 w-11 shrink-0 items-center justify-center rounded-lg',
                  palette.soft,
                  palette.text,
                )}
              >
                {feature.icon}
              </span>
              <div>
                <h3 className="text-h4 font-sans font-semibold text-text-primary">{feature.title}</h3>
                <p className="mt-1.5 text-body text-text-secondary">{feature.description}</p>
              </div>
            </li>
          );
        })}
      </ul>

      <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-lg border border-border bg-background-card shadow-xs">
        <span aria-hidden="true" className={cn('block h-1', accent('cyan').rule)} />
        <div className="px-6 py-10 text-center sm:px-10">
          <h3 className="text-h3 text-text-primary">Ready to join our community?</h3>
          <p className="mx-auto mt-4 max-w-2xl text-body-lg text-text-secondary">
            Become part of a global network of scholars, researchers, and students passionate about advancing knowledge.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <Button
              onClick={() => window.open('https://t.me/mindalitix', '_blank')}
              className="w-full sm:w-auto"
            >
              Join Telegram
            </Button>
            <Button
              variant="secondary"
              onClick={() => window.open('https://discord.gg/dTxJ2twG', '_blank')}
              className="w-full sm:w-auto"
            >
              Join Discord
            </Button>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default CommunitySection
